import script from "./IbSalesInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./IbSalesInfo.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__